import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { WebMenuNode } from 'app/com/ibm/tw/commons/beans/web.menu.node';
import { EventData, StatusService } from 'ui-components/common';
import { DomHandler } from 'ui-components/dom';
import { ValidatorService } from 'ui-components/validator';
import { AxthenticationService } from '../../../../../services/axthentication.service';

declare function closeAllPopupPanel(): void;

@Component({
    standalone: false,
    selector: 'megamenu',
    templateUrl: './megamenu.component.html'
})

export class MegaMenuComponent implements OnInit, OnDestroy {

    @Input() menuList: WebMenuNode = null; // 主選單

    @Output() onClick: EventEmitter<any> = new EventEmitter();

    public currentMenuId: string;

    /** 用於追蹤此元件創建的 CSS 規則，以便在銷毀時清理 */
    private createdCssRules: string[] = [];

    constructor(
        public el: ElementRef, public domHandler: DomHandler,
        private router: Router,
        private validatorService: ValidatorService,
        private axthenticationService: AxthenticationService,
        private statusService: StatusService) {
    }

    ngOnInit() {
        this.menuList = this.axthenticationService.menu;
    }

    toggleMainMenu(event, menu: WebMenuNode) {

        // 觸發元件的body click事件，讓它們隱藏，如dropdown、calendar
        document.body.click();

        // 關閉所有的Javascript產生的popup
        closeAllPopupPanel();

        try {
            event.srcElement.focus();
        } catch (e) { }

        // // console.log('this.currentMenuId ==' + this.currentMenuId + ' menu.menuIxd=' + menu.menuIxd);
        if (this.currentMenuId !== menu.menuIxd) {
            this.currentMenuId = menu.menuIxd;
            let liNode = event.target.parentNode;
            let id = liNode.getAttribute('id');

            // console.log('liNode...' + liNode.tagName + '.....' + id);

            // 主 Menu 的長條區塊
            let menuDiv: HTMLElement = document.getElementById('menu');

            let divTag = liNode.parentNode;
            while (divTag.tagName !== 'DIV') {
                divTag = divTag.parentNode;
            }

            // 取得第二層Menu的Tag,用來計算寬度
            let hrsubTag: HTMLElement[] = this.domHandler.find(liNode, 'div.cbp-hrsub');

            // CSP-compliant: Reset position using DomHandler
            this.domHandler.addDynamicCssRule(hrsubTag[0], 'left', '', 'megamenu', this.createdCssRules);
            this.domHandler.addDynamicCssRule(hrsubTag[0], 'right', '', 'megamenu', this.createdCssRules);

            let x;

            if (window.scrollX) {
                x = window.scrollX;
            } else {
                x = window.pageXOffset;
            }

            // console.log('網頁可見區域寬：' + document.body.clientWidth);
            // console.log('網頁可見區域高：' + document.body.clientHeight);
            // console.log('網頁可見區域寬：' + document.body.offsetWidth + '(包括邊線和捲軸的寬');
            // console.log('網頁可見區域高：' + document.body.offsetHeight + ' (包括邊線的寬)');
            // console.log('網頁正文全文寬：' + document.body.scrollWidth);
            // console.log('網頁正文全文高：' + document.body.scrollHeight);

            let scrollWidth = document.body.scrollWidth - document.body.clientWidth;

            let leftPos = liNode.getBoundingClientRect().left + x;

            let mainTabWidth = (liNode.offsetWidth) * 2;

            // menu有幾個column
            let submenuColumn = menu.children.length;
            if (submenuColumn > 4) {
                submenuColumn = 4;
            }

            let subMenuLocation = leftPos;
            // console.log('subMenuLocation ====' + subMenuLocation + ',menu.children.length =' + menu.children.length);
            if (menu.children.length > 1) {

                // sub menu 的寬度和位置
                let subMenuCountLocation = (subMenuLocation + (submenuColumn * 295));
                // console.log(' subMenuCountLocation ====' + subMenuCountLocation);

                if (subMenuCountLocation > menuDiv.offsetWidth) {

                    let halfWidth: number = menuDiv.offsetWidth / 2;

                    if (subMenuCountLocation > document.body.clientWidth) {
                        // 如果menu比較靠右的話，就將子menu向右靠齊
                        if (subMenuLocation > (halfWidth + scrollWidth + 65)) {
                            // CSP-compliant: Set position using DomHandler
                            this.domHandler.addDynamicCssRule(hrsubTag[0], 'right', '0px', 'megamenu', this.createdCssRules);
                        } else {
                            // CSP-compliant: Set position using DomHandler
                            this.domHandler.addDynamicCssRule(hrsubTag[0], 'left', '0px', 'megamenu', this.createdCssRules);
                        }
                    } else {
                        // CSP-compliant: Set position using DomHandler
                        this.domHandler.addDynamicCssRule(hrsubTag[0], 'right', '0px', 'megamenu', this.createdCssRules);
                    }

                }
            }

        } else {
            this.currentMenuId = '';
        }
        //  event.preventDefault();
    }

    /**
     * 點擊menu
     * @param event
     * @param clickmenu
     */
    toggleSubMainMenu(event, clickmenu: WebMenuNode) {
        let haveLeaf: boolean = clickmenu.children.length > 0;
        if (haveLeaf) {
            // 畫面展開
            if (clickmenu.display === 'none') {
                clickmenu.display = '';
                clickmenu.styleClass = 'tre_nav on';
            } else {
                clickmenu.display = 'none';
                clickmenu.styleClass = 'tre_nav';
            }
        } else {

            this.currentMenuId = '';

            let eventData: EventData = new EventData(event, clickmenu.url, true, null);

            eventData.taskID = clickmenu.taskIxd;

            clickmenu.areaType = this.axthenticationService.currentArea;

            eventData.originalEvent = clickmenu;

            // 進行click動作
            this.onClick.emit(eventData);
        }
        //  event.preventDefault();
    }

    @HostListener('mouseleave', ['$event'])
    onMouseLeave(e: Event) {
        this.currentMenuId = '';
    }

    /**
     * Cleanup just before Angular destroys the directive/component.
     */
    ngOnDestroy() {
        // Clean up created CSS rules
        if (this.createdCssRules.length > 0) {
            this.domHandler.cleanupDynamicCssRules('megamenu', this.createdCssRules);
        }
    }

}
